import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function QuestionsPage() {
  return <InstituteCrudPage config={entityConfigs['questions']} />;
}
